// Valid locales for Footer and Header
export const validLocales = [
  "ar-AE-DU",
  "ar-EG",
  "az-AZ",
  "bg-BG",
  "bs-BA",
  "cs-CZ",
  "cs-SK",
  "da-DK",
  "de-AT",
  "de-CH",
  "de-DE",
  "de-LI",
  "de-LU",
  "el-GR",
  "en-AE-AZ",
  "en-AE-DU",
  "en-AE-FU",
  "en-AE-SH",
  "en-AL",
  "en-AP",
  "en-asia-pacific",
  "en-AU",
  "en-BA",
  "en-BG",
  "en-BH",
  "en-BN",
  "en-CA",
  "en-CE",
  "en-CH",
  "en-CN",
  "en-CW",
  "en-CY",
  "en-CZ",
  "en-DK",
  "en-eastern-europe",
  "en-EE",
  "en-EG",
  "en-FI",
  "en-GB",
  "en-GE",
  "en-GH",
  "en-GR",
  "en-HK",
  "en-HR",
  "en-HT",
  "en-HU",
  "en-ID",
  "en-IE",
  "en-IN",
  "en-international",
  "en-IS",
  "en-JM",
  "en-JO",
  "en-KH",
  "en-KR",
  "en-KW",
  "en-latin-america",
  "en-LB",
  "en-LI",
  "en-LK",
  "en-LL",
  "en-LT",
  "en-LV",
  "en-ME",
  "en-middle-east",
  "en-MK",
  "en-MN",
  "en-MT",
  "en-MU",
  "en-MY",
  "en-NC",
  "en-NG",
  "en-NL",
  "en-NO",
  "en-NZ",
  "en-OM",
  "en-PF",
  "en-PH",
  "en-PL",
  "en-PR",
  "en-PT",
  "en-QA",
  "en-RO",
  "en-RS",
  "en-SA",
  "en-SE",
  "en-SG",
  "en-SI",
  "en-SK",
  "en-TH",
  "en-TR",
  "en-TT",
  "en-TW",
  "en-US",
  "en-UZ",
  "en-VN",
  "en-WW",
  "en-XA",
  "en-XD",
  "en-ZA",
  "es-AD",
  "es-AR",
  "es-BO",
  "es-CL",
  "es-CO",
  "es-CR",
  "es-DO",
  "es-EC",
  "es-ES",
  "es-GT",
  "es-HN",
  "es-latin-america",
  "es-LL",
  "es-MX",
  "es-PA",
  "es-PE",
  "es-PY",
  "es-SV",
  "es-UY",
  "et-EE",
  "fi-FI",
  "fr-BE",
  "fr-CA",
  "fr-CH",
  "fr-DZ",
  "fr-FR",
  "fr-GP",
  "fr-LI",
  "fr-LU",
  "fr-MA",
  "fr-MC",
  "fr-ME",
  "fr-middle-east",
  "fr-MQ",
  "fr-MU",
  "fr-NC",
  "fr-PF",
  "fr-RE",
  "fr-TN",
  "he-IL",
  "hr-HR",
  "hu-HU",
  "hy-AM",
  "it-CH",
  "it-IT",
  "it-LI",
  "ja-JP",
  "ka-GE",
  "ko-KR",
  "lt-LT",
  "lv-LV",
  "mk-MK",
  "nl-BE",
  "nl-NL",
  "no-NO",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "ro-MD",
  "ro-RO",
  "ru-AM",
  "ru-AZ",
  "ru-BY",
  "ru-CE",
  "ru-CY",
  "ru-eastern-europe",
  "ru-EE",
  "ru-KZ",
  "ru-LT",
  "ru-LV",
  "ru-MD",
  "ru-RU",
  "ru-UA",
  "ru-UZ",
  "sk-SK",
  "sl-SI",
  "sr-RS",
  "sv-SE",
  "tr-TR",
  "uk-UA",
  "uz-UZ",
  "zh-CN",
  "zh-TW"
];

// Mapping of PAG Market Area IDs to possible region-language combinations
// Future-proof if new languages become valid locales for Footer and Header
export const marketAreaLocales: Record<string, string[]> = {
  PCNA: ["en-US"],
  PBR: ["pt-BR"],
  PLA: [
    "es-AR",
    "es-CL",
    "es-CO",
    "es-DO",
    "es-EC",
    "es-SV",
    "fr-GP",
    "es-GT",
    "en-JM",
    "es-MX",
    "es-PA",
    "es-PY",
    "gu-PY",
    "es-PE",
    "qu-PE",
    "es-PR",
    "en-PR",
    "en-TT"
  ],
  PCL: ["en-CA", "fr-CA"],
  ICL: ["en-CA", "fr-CA"],
  ICNA: ["en-US"],
  ILA: [
    "es-AR",
    "es-CL",
    "es-CO",
    "es-DO",
    "es-EC",
    "es-SV",
    "fr-GP",
    "es-GT",
    "en-JM",
    "es-MX",
    "es-PA",
    "es-PY",
    "gu-PY",
    "es-PE",
    "qu-PE",
    "es-PR",
    "en-PR",
    "en-TT"
  ],
  PCEE: [
    "hy-AM",
    "az-AZ",
    "bs-BA",
    "bg-BG",
    "hr-HR",
    "cs-CZ",
    "et-EE",
    "ka-GE",
    "el-GR",
    "hu-HU",
    "he-IL",
    "ru-KZ",
    "lv-LV",
    "lt-LT",
    "mk-MK",
    "ro-MD",
    "ro-RO",
    "sr-RS",
    "sk-SK",
    "sl-SI",
    "uk-UA",
    "uz-UZ",
    "tr-TR"
  ],
  PCGB: ["en-GB"],
  PCH: ["de-CH", "fr-CH", "it-CH"],
  PD: ["de-DE"],
  PIB: ["es-ES", "pt-PT"],
  PIT: ["it-IT"],
  POF: ["fr-FR"],
  PNE: [
    "nl-NL",
    "nl-BE",
    "fr-BE",
    "de-BE",
    "no-NO",
    "lb-LU",
    "fr-LU",
    "de-LU",
    "en-NL"
  ],
  ID: ["de-DE"],
  IBE: ["nl-BE", "fr-BE", "de-BE"],
  ICEE: [
    "hy-AM",
    "az-AZ",
    "bs-BA",
    "bg-BG",
    "hr-HR",
    "cs-CZ",
    "et-EE",
    "ka-GE",
    "el-GR",
    "hu-HU",
    "he-IL",
    "ru-KZ",
    "lv-LV",
    "lt-LT",
    "mk-MK",
    "ro-MD",
    "ro-RO",
    "sr-RS",
    "sk-SK",
    "sl-SI",
    "uk-UA",
    "uz-UZ",
    "tr-TR"
  ],
  ICGB: ["en-GB"],
  ICH: ["de-CH", "fr-CH", "it-CH"],
  IIB: ["es-ES", "pt-PT"],
  IIT: ["it-IT"],
  INO: ["no-NO"],
  IOF: ["fr-FR"],
  IPL: ["pl-PL"],
  INL: ["nl-NL"],
  ILU: ["lb-LU", "fr-LU", "de-LU"],
  PNO: ["no-NO"],
  PIS: ["de-DE"],
  PPL: ["pl-PL"],
  PAP: [
    "si-LK",
    "ta-LK",
    "th-TH",
    "vi-VN",
    "ms-MY",
    "en-MY",
    "ms-BN",
    "en-BN",
    "mn-MN",
    "ru-MN",
    "tl-PH",
    "en-PH",
    "id-ID",
    "en-ID",
    "en-SG",
    "zh-SG",
    "ms-SG",
    "ta-SG",
    "km-KH",
    "fr-NC",
    "fr-PF",
    "en-NZ",
    "mi-NZ"
  ],
  PCA: ["en-AU"],
  PJ: ["ja-JP"],
  PKO: ["ko-KR"],
  PME: [
    "ar-LB",
    "fr-LB",
    "ar-JO",
    "ar-KW",
    "ar-BH",
    "en-GH",
    "ar-SA",
    "ar-AE",
    "en-MU",
    "fr-MU",
    "fr-RE",
    "ar-MA",
    "fr-MA",
    "ar-TN",
    "fr-TN",
    "ar-EG",
    "en-EG",
    "ar-QA",
    "hi-IN",
    "en-IN",
    "ar-OM",
    "en-ZA",
    "af-ZA",
    "zu-ZA",
    "xh-ZA",
    "en-KE",
    "sw-KE",
    "ar-AE-DU",
    "en-AE-AZ",
    "en-AE-DU",
    "en-AE-FU",
    "en-AE-SH"
  ],
  PTW: ["zh-TW"],
  ICA: ["en-AU"],
  IJ: ["ja-JP"],
  IHK: ["zh-HK"],
  ITW: ["zh-TW"],
  IKO: ["ko-KR"],
  IAP: [
    "si-LK",
    "ta-LK",
    "th-TH",
    "vi-VN",
    "ms-MY",
    "en-MY",
    "ms-BN",
    "en-BN",
    "mn-MN",
    "ru-MN",
    "tl-PH",
    "en-PH",
    "id-ID",
    "en-ID",
    "en-SG",
    "zh-SG",
    "ms-SG",
    "ta-SG",
    "km-KH",
    "fr-NC",
    "fr-PF",
    "en-NZ",
    "mi-NZ"
  ],
  PGCN: ["zh-CN"]
};

/**
 * Maps browser locales to the corresponding application locale.
 * Additional browser locale aliases can be added here.
 */
const browserLocaleAliases: Record<string, string> = {
  "nb": "no-NO",
  "nn": "no-NO",
  "nb-NO": "no-NO",
  "nn-NO": "no-NO"
};

/**
 * Defines the preferred regional locale if the browser only provides
 * a language without a region.
 */
const preferredLocalesByLanguage: Record<string, string> = {
  ro: "ro-RO"
};

export function splitLocale(locale: string) {
  const [lang, region] = locale.split("-");

  return { lang, region };
}

function normalizeBrowserLocale(browserLocale: string): string {
  return browserLocaleAliases[browserLocale] ?? browserLocale;
}

export function resolveUserLocale(browserLocale: string): string {
  const params = new URLSearchParams(new URL(window.location.href).search);
  const marketAreaId = params.get("Importer") || "";
  const allowed = marketAreaLocales[marketAreaId] || [];

  if (!allowed.length) {
    return "en-WW";
  }

  const normalizedBrowserLocale = normalizeBrowserLocale(browserLocale);

  // Return an exact match, including configured browser locale aliases
  if (
    validLocales.includes(normalizedBrowserLocale) &&
    allowed.includes(normalizedBrowserLocale)
  ) {
    return normalizedBrowserLocale;
  }

  const { lang: browserLang, region: browserRegion } = splitLocale(
    normalizedBrowserLocale
  );

  // Apply a configured default if the browser provides no region
  if (!browserRegion) {
    const preferredLocale = preferredLocalesByLanguage[browserLang];

    if (
      preferredLocale &&
      validLocales.includes(preferredLocale) &&
      allowed.includes(preferredLocale)
    ) {
      return preferredLocale;
    }
  }

  // Return the locale if exactly one valid candidate exists for the language
  const candidates = allowed.filter(locale => {
    return (
      splitLocale(locale).lang === browserLang &&
      validLocales.includes(locale)
    );
  });

  if (candidates.length === 1) {
    return candidates[0];
  }

  return "en-WW";
}

export let userLocale: string = resolveUserLocale(
  navigator.languages?.[0] || navigator.language
);

export function setUserLocale(next: string) {
  userLocale = next;
}

/**
 * Determines the best initial locale to use based on the user's browser language
 * and the list of languages available in the application.
 *
 * @param browserLang The user's full browser language, for example "de-CH".
 * @param availableLangs The array of all valid locales in the application.
 * @returns The best matching locale string.
 */
export function getInitialLocale(
  browserLang: string,
  availableLangs: readonly string[]
): string {
  const normalizedBrowserLocale = normalizeBrowserLocale(browserLang);

  if (availableLangs.includes(normalizedBrowserLocale)) {
    return normalizedBrowserLocale;
  }

  const { lang, region } = splitLocale(normalizedBrowserLocale);

  if (!region) {
    const preferredLocale = preferredLocalesByLanguage[lang];

    if (preferredLocale && availableLangs.includes(preferredLocale)) {
      return preferredLocale;
    }
  }

  return "en-WW";
}